<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="DiscountActivityName" label="名称" width>
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
        </el-table-column>
        <el-table-column prop="DiscountMode" label="折扣模式" width :formatter="formatDiscountMode">
        </el-table-column>
        <!-- <el-table-column prop="FullAmount" label="满减金额" width>
        </el-table-column> -->
        <el-table-column prop="DiscountAmount" label="折扣金额" width>
        </el-table-column>
        <!-- <el-table-column prop="DiscountRatio" label="折扣比例" width>
        </el-table-column>
        <el-table-column prop="MaxDiscountLimit" label="最大折扣限额" width>
        </el-table-column> -->
        <el-table-column prop="ValidPeriodStartTime" label="开始时间" width>
        </el-table-column>
        <el-table-column prop="ValidPeriodEndTime" label="结束时间" width>
        </el-table-column>
        <el-table-column prop="DiscountPriorityLevel" label="优先级" width>
        </el-table-column>
        <el-table-column prop="Remarks" label="备注" width="">
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间">
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑优惠补贴信息" :visible.sync="editFormVisible" v-model="editFormVisible"
        :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">

          <el-form-item label="名称" prop="DiscountActivityName">
            <el-input v-model="editForm.DiscountActivityName" auto-complete="off"></el-input>
          </el-form-item>



          <el-form-item label="折扣模式">

            <el-radio-group v-model="editForm.DiscountMode" v-removeAriaHidden>
              <el-radio class="radio" :label="1">固定金额</el-radio>
              <!-- <el-radio class="radio" :label="2">比例金额</el-radio> -->
            </el-radio-group>
          </el-form-item>

          <el-row :gutter="20" v-if="editForm.DiscountMode == 1">
            <!-- <el-col :span="12">
              <el-form-item label="满减金额" prop="FullAmount">
                <el-input-number v-model="editForm.FullAmount" :min="0" :controls="true" :step="0.1"></el-input-number>
              </el-form-item>

            </el-col> -->
            <el-col :span="12">
              <el-form-item label="折扣金额" prop="DiscountAmount">
                <el-input-number v-model="editForm.DiscountAmount" :min="0" :controls="true"
                  :step="0.1"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="editForm.DiscountMode == 2">
            <el-col :span="12">
              <el-form-item label="折扣比例" prop="DiscountRatio">
                <el-input-number v-model="editForm.DiscountRatio" :min="0" :max="1" :controls="true"
                  :step="0.1"></el-input-number>
              </el-form-item>

            </el-col>
            <el-col :span="12">
              <el-form-item label="最大折扣限额" prop="MaxDiscountLimit">
                <el-input-number v-model="editForm.MaxDiscountLimit" :min="0" :controls="true"
                  :step="0.1"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="有效期时间" prop="TimeArr">
            <el-date-picker v-model="editForm.TimeArr" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="优先级" prop="DiscountPriorityLevel">
            <div class="ds-priority-field">
              <el-input-number v-model="editForm.DiscountPriorityLevel"></el-input-number>
              <p class="ds-form-tip">
                <i class="el-icon-info ds-form-tip__icon"></i>
                <span>同一就餐时间段存在多个优惠，按照优先级最大的进行折扣，不可叠加使用</span>
              </p>
            </div>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增优惠补贴信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="名称" prop="DiscountActivityName">
            <el-input v-model="addForm.DiscountActivityName" auto-complete="off"></el-input>
          </el-form-item>



          <el-form-item label="折扣模式">

            <el-radio-group v-model="addForm.DiscountMode" v-removeAriaHidden>
              <el-radio class="radio" :label="1">固定金额</el-radio>
              <!-- <el-radio class="radio" :label="2">比例金额</el-radio> -->
            </el-radio-group>
          </el-form-item>

          <el-row :gutter="20" v-if="addForm.DiscountMode == 1">
            <!-- <el-col :span="12">
              <el-form-item label="满减金额" prop="FullAmount">
                <el-input-number v-model="addForm.FullAmount" :min="0" :controls="true" :step="0.1"></el-input-number>
              </el-form-item>

            </el-col> -->
            <el-col :span="12">
              <el-form-item label="折扣金额" prop="DiscountAmount">
                <el-input-number v-model="addForm.DiscountAmount" :min="0" :controls="true"
                  :step="0.1"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="addForm.DiscountMode == 2">
            <el-col :span="12">
              <el-form-item label="折扣比例" prop="DiscountRatio">
                <el-input-number v-model="addForm.DiscountRatio" :min="0" :max="1" :controls="true"
                  :step="0.1"></el-input-number>
              </el-form-item>

            </el-col>
            <el-col :span="12">
              <el-form-item label="最大折扣限额" prop="MaxDiscountLimit">
                <el-input-number v-model="addForm.MaxDiscountLimit" :min="0" :controls="true"
                  :step="0.1"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="有效期时间" prop="TimeArr">
            <el-date-picker v-model="addForm.TimeArr" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="优先级" prop="DiscountPriorityLevel">
            <div class="ds-priority-field">
              <el-input-number v-model="addForm.DiscountPriorityLevel"></el-input-number>
              <p class="ds-form-tip">
                <i class="el-icon-info ds-form-tip__icon"></i>
                <span>同一就餐时间段存在多个优惠，按照优先级最大的进行折扣，不可叠加使用</span>
              </p>
            </div>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getDiscountSubsidyListPage, removeDiscountSubsidy, editDiscountSubsidy, addDiscountSubsidy } from '../../api/modules/consumption';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        DiscountActivityName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        TimeArr: [
          { required: true, message: '请选择有效时间', trigger: 'change' }
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        DiscountActivityName: "",
        DiscountMode: 1,
        Remarks: "",
        DepartmentId: 0,
        FullAmount: 0,
        DiscountAmount: 0,
        DiscountRatio: 0,
        MaxDiscountLimit: 0,
        ValidPeriodStartTime: '',
        ValidPeriodEndTime: '',
        TimeArr: [],
        DiscountPriorityLevel: 0
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        DiscountActivityName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        TimeArr: [
          { required: true, message: '请选择有效时间', trigger: 'change' }
        ],
      },
      //新增界面数据
      addForm: {
        DiscountActivityName: "",
        DiscountMode: 1,
        Remarks: "",
        DepartmentId: 0,
        FullAmount: 0,
        DiscountAmount: 0,
        DiscountRatio: 0,
        MaxDiscountLimit: 0,
        ValidPeriodStartTime: '',
        ValidPeriodEndTime: '',
        TimeArr: [],
        DiscountPriorityLevel: 0
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false
    };
  },
  methods: {
    formatDiscountMode: function (row, column) {

      var str = "";
      if (row.DiscountMode == '1') {
        str = "固定金额";
      } else if (row.DiscountMode == '2') {
        str = "比例金额"
      }

      return str;
    },
    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getDiscountSubsidyListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeDiscountSubsidy(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    // 显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    // 显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.options = [];
      this.addForm = {
        DiscountActivityName: "",
        DiscountMode: 1,
        Remarks: "",
        DepartmentId: this.DepartmentId,
        FullAmount: 0,
        DiscountAmount: 0,
        DiscountRatio: 0,
        MaxDiscountLimit: 0,
        ValidPeriodStartTime: '',
        ValidPeriodEndTime: '',
        TimeArr: [],
        DiscountPriorityLevel: 0
      };
    },
    // 编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.ValidPeriodStartTime = para.TimeArr[0] || ""
            para.ValidPeriodEndTime = para.TimeArr[1] || ""

            editDiscountSubsidy(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    // 新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.ValidPeriodStartTime = para.TimeArr[0] || ""
            para.ValidPeriodEndTime = para.TimeArr[1] || ""

            addDiscountSubsidy(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.ds-priority-field {
  width: 100%;
}

.ds-form-tip {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 8px 0 0;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.55;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.ds-form-tip__icon {
  flex-shrink: 0;
  margin-top: 1px;
  font-size: 14px;
  color: var(--btn-primary, #2563eb);
}
</style>
